import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';

const SearchField = ({
  value,
  onChange
}: {
  value: string;
  onChange: (value: string) => void;
}) => {
  return (
    <TextField
      id="url-search-input"
      placeholder="https://www.amazon.com/gp/product/B09VFGB4JH etc"
      value={value}
      label="Amazon.com URL"
      onChange={(e) => onChange(e.target.value)}
      style={{ margin: '10px 0 0 0' }}
      fullWidth
      InputProps={{
        endAdornment:
          value.length > 0 ? (
            <InputAdornment position="end">
              <IconButton
                aria-label="Clear search input"
                onClick={() => {
                  onChange('');
                }}
                edge="end"
              >
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ) : null
      }}
    />
  );
};

export default SearchField;
